import React from "react";
import IconButton from "@mui/material/IconButton";
import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    TextField,
    Typography, Stack
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePermission } from "../../index";
import {setRightDrawer} from "../../../../Common/App";


export const EditPermission = () => {

    const dispatch = useDispatch();
    const items = useSelector((store)=> store.permissions);
    const [disabled, setDisabled] = useState(true);
    const [data, setData] = useState({})
    const [, setResponse] = useState({});

    useEffect(() => {
        setData(items.selected);
    },[items.selected])

    const handleChange = (e) => {
        if (e.target.name !== 'label') {
            return;
        }

        setDisabled(false);
        setData((prev) => ({
            ...prev,
            label: e.target.value,
        }));
    }

    const handleSubmit = async () => {
        setDisabled(true);
        await updatePermission({
            dispatch,
            data: {
                id: data.id,
                label: data.label,
            },
        }).then((res) => setResponse(res))
    };

    return(
        <Card sx={{ height: '100%', position:'relative', display: 'flex', flexDirection:'column', alignItems:'stretch', justifyContent:'flex-start', alignContent:'stretch' }}>
            <CardHeader
                action={
                    <IconButton aria-label="share" onClick={()=> dispatch(setRightDrawer({component:null, open:false}))}>
                        <CloseIcon />
                    </IconButton>
                }
                avatar={
                    <Typography>Edit Permission</Typography>
                }
            />
            <CardContent sx={{ flex:1 }}>
                { (data !== undefined && Object.keys(data).length > 0) &&
                    <Stack spacing={3} sx={{py:1}}>
                        <TextField
                            fullWidth
                            label="Permission Name"
                            name="name"
                            value={data.name || ''}
                            variant="outlined"
                            size="large"
                            InputProps={{ readOnly: true }}
                        />
                        <TextField
                            fullWidth
                            label="Label"
                            name="label"
                            onChange={handleChange}
                            value={data.label || ''}
                            variant="outlined"
                            size="large"
                            helperText={items.error?.label}
                        />
                    </Stack>
                }
            </CardContent>
            <CardActions className={'card-footer'} sx={{ p:2, display:'flex', justifyContent:'space-between'}}>
                <Button disabled={disabled} color="primary" variant="contained" onClick={ handleSubmit }>Save</Button>
                <Button variant={'contained'} color={'secondary'} onClick={()=> dispatch(setRightDrawer({component:null, open:false}))}>Close</Button>
            </CardActions>
        </Card>
    )
}
